/* 搜索管理 */
import request from '../utils/request'

export const switchSiteAPI = data => {
	return request({
		url: '/site/switch',
		method: 'post',
		data,
	})
}

/* 获取结果数据 */
export const getResultListAPI = data => {
	return request({
		url: '/site/list',
		method: 'get',
		data,
	})
}

/* 添加站点 */
export const addSiteAPI = data => {
	return request({
		url: '/site/add',
		method: 'post',
		data,
	})
}

/* 确认添加 */
export const confirmSiteAPI = data => {
	return request({
		url: '/site/confirm',
		method: 'post',
		data,
	})
}

/* 是否可以添加 */
export const siteCanAddSiteAPI = data => {
	return request({
		url: '/site/can_add_site',
		method: 'get',
		data,
	})
}
/* 是否可以添加 */
export const getCollaborativeList = data => {
	return request({
		url: '/site/collaborative_list',
		method: 'get',
		data,
	})
}

